<template>
  <h1>设备在线管理</h1>
  <div class="mb-20 flex items-center">
    <div class="mr-20 flex items-center">
      <div class="mr-20">
        <span>设备 MAC 地址：</span>
        <el-input
          v-model="searchFilter.mac"
          style="width: 180px"
          placeholder="请输入"
        />
      </div>
      <div class="mr-20">
        <span>所属单位：</span>
        <el-input
          v-model="searchFilter.unit"
          style="width: 180px"
          placeholder="请输入"
        />
      </div>
      <div class="mr-20">
        <span>在线状态：</span>
        <el-select
          v-model="searchFilter.status"
          style="width: 180px"
          placeholder="请输入"
        >
          <el-option
            v-for="item in [
              { label: '在线', val: 1 },
              { label: '不在线', val: 0 },
              { label: '全部', val: 2 },
            ]"
            :key="item.val"
            :label="item.label"
            :value="item.val"
          >
          </el-option>
        </el-select>
      </div>
    </div>

    <div>
      <el-button class="mr-10" @click="search" :icon="Search">查询</el-button>
      <el-button @click="resetFilter">重置</el-button>
    </div>
    <!-- 新增MAC地址按钮 -->
    <div>
      <el-button
        class="mr-10"
        style="margin-left: 20px"
        @click="showDialog = true"
        ><el-icon><Plus /></el-icon>新增MAC地址</el-button
      >
    </div>
  </div>
  <el-dialog v-model="showDialog" title="新增MAC地址" width="30%">
    <el-form :model="form" :rules="rules" ref="formRef">
      <el-form-item label="MAC地址" prop="macAddress">
        <el-input v-model="form.macAddress" placeholder="请输入MAC地址" />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="showDialog = false">取消</el-button>
        <el-button type="primary" @click="submitForm">提交</el-button>
      </span>
    </template>
  </el-dialog>
  <el-table
    class="equipment-list mb-20"
    :data="filterData"
    border
    style="width: 100%"
  >
    <el-table-column sortable prop="mac" label="设备MAC地址" />
    <el-table-column sortable prop="user_company" label="所属单位" />
    <el-table-column sortable prop="last_heartbeat" label="是否在线时间">
      <template #default="{ row }">
        {{
          row.last_heartbeat
            ? dayjs(row.last_heartbeat).format("YYYY-MM-DD HH:mm:ss")
            : ""
        }}
      </template>
    </el-table-column>
    <el-table-column prop="" label="状态">
      <template #default="{ row }">
        <span>{{ row.is_online ? "在线" : "不在线" }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="" label="操作">
      <template #default="{ row }">
        <el-button type="primary" text class="mr-10" @click="removeMac(row)"
          >删除</el-button
        >
      </template>
    </el-table-column>
  </el-table>
  <!-- <div class="page-block flex justify-end">
    <el-pagination
      v-model:current-page="searchFilter.page"
      v-model:page-size="searchFilter.pageSize"
      :page-sizes="[20, 50, 100, 200]"
      layout="prev, pager, next,sizes, total"
      :total="total"
      background
    />
  </div> -->
</template>

<script lang="ts" setup>
import { ElMessage } from "element-plus";
import dayjs from "dayjs";
import { onMounted, ref, computed } from "vue";
import { Search } from "@element-plus/icons-vue";
import { getMacApi, addMacApi, removeMacApi } from "@/api/index";
const searchFilter = ref({
  status: 2,
  unit: "",
  mac: "",
  page: 1,
  pageSize: 20,
});
// 控制对话框显示
const showDialog = ref(false);
// 表单数据
const form = ref({
  macAddress: "",
});
// 验证规则
const rules = {
  macAddress: [
    { required: true, message: "请输入MAC地址" },
    // {
    //   pattern: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
    //   message: "请输入正确的MAC地址格式(如: 00:1A:2B:3C:4D:5E)",
    //   trigger: "blur",
    // },
  ],
};
const formRef = ref();
// 提交表单
const submitForm = async () => {
  try {
    // 验证表单
    const valid = await formRef.value.validate().catch(() => false);
    if (!valid) return;
    // 调用API接口
    const response = await addMacApi(form.value.macAddress);
    // 处理响应
    if (response.code === "success") {
      ElMessage.success(response.message);
      showDialog.value = false;
      form.value.macAddress = ""; // 清空表单
      getEquimentList();
      // 这里可以添加其他成功后的逻辑，如刷新列表等
    } else {
      ElMessage.error(response.message || "添加失败");
    }
  } catch (error) {
    console.error("提交失败:", error);
    ElMessage.error("提交失败，请检查网络或联系管理员");
  }
};
const tableData = ref([]);
const filterData = computed(() => {
  return tableData.value.filter((item) => {
    const { status, mac, unit } = searchFilter.value;

    // 检查 mac 和 unit 是否匹配（如果为空则跳过匹配）
    const isMacMatch = !mac || item.mac?.includes(mac);
    const isUnitMatch = !unit || item.user_company?.includes(unit);

    // 如果 status 是 2，只匹配 mac 和 unit，不管是否在线
    if (status === 2) {
      return isMacMatch && isUnitMatch;
    }
    // 如果 status 是 1，匹配在线设备 + mac + unit
    else if (status === 1) {
      return item.is_online && isMacMatch && isUnitMatch;
    }
    // 其他情况（如 status 是 0 或未定义），匹配离线设备 + mac + unit
    else {
      return !item.is_online && isMacMatch && isUnitMatch;
    }
  });
});
const total = ref(100);
const resetFilter = () => {
  searchFilter.value.mac = "";
  searchFilter.value.unit = "";
  searchFilter.value.status = 2;
};
const removeMac = async (row) => {
  const res = await removeMacApi(row.mac);
  if (res.code === "success") {
    ElMessage.success(res.message);
    getEquimentList();
    return;
  }
  ElMessage.error(res.message);
};
const search = () => {
  searchFilter.value.page = 1;
  searchFilter.value.pageSize = 20;
  getEquimentList();
};
const getEquimentList = async () => {
  const res = await getMacApi();
  if (res.code === "success") {
    tableData.value = res.content;
  }
};

onMounted(() => {
  getEquimentList();
});
</script>

<style lang="scss" scoped>
.text-right {
  text-align: right;
}
.mb-20 {
  margin-bottom: 20px;
}
.mt-20 {
  margin-top: 20px;
}
.mr-20 {
  margin-right: 20px;
}
.mr-10 {
  margin-right: 10px;
}

.justify-end {
  justify-content: end;
}
.flex {
  display: flex;
}
.items-center {
  align-items: center;
}
.justify-between {
  justify-content: space-between;
}
.flex-1 {
  flex: 1;
}
.equipment-list {
  height: calc(100% - 140px);
}
.page-block {
  z-index: 9;
  background-color: #fff;
  width: calc(100% - 312px);
  box-shadow: 0 -5px 10px -5px rgba(0, 0, 0, 0.1),
    0 5px 10px -5px rgba(0, 0, 0, 0.1);
  padding: 10px;
  position: fixed;
  bottom: 0;
  right: 26px;
}
</style>
